import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../assets/speedtest.png'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "text-center" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "Measure your internet speed!"),
  /*#__PURE__*/_createElementVNode("div", { class: "subtitle-1 mt-n1" }, "One click get your Internet speed")
], -1)
const _hoisted_2 = { class: "mt-3 mx-2 mx-md-8 d-flex justify-center image-holder" }
const _hoisted_3 = {
  target: "_blank",
  href: "https://jtel.speedtestcustom.com/"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_v_img, {
        src: _imports_0,
        height: "100%"
      }),
      _createElementVNode("a", _hoisted_3, [
        _createVNode(_component_v_btn, { class: "btn-primary on-image checkout" }, {
          default: _withCtx(() => [
            _createTextVNode("Check out")
          ]),
          _: 1
        })
      ])
    ])
  ], 64))
}